export enum CreatePasskeyMessageType {
  SUCCESS = 'WEBAUTHN_CREATE_PASSKEY_SUCCESS',
  ERROR = 'WEBAUTHN_CREATE_PASSKEY_ERROR',
  CANCELLED = 'WEBAUTHN_CREATE_PASSKEY_CANCELLED',
}

export enum CreatePasskeyErrorCode {
  CANCELLED = 'CANCELLED',
  TIMEOUT = 'TIMEOUT',
  DUPLICATE_PASSKEY = 'DUPLICATE_PASSKEY',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  GENERAL = 'GENERAL',
}

export interface CreatePasskeyMessage {
  type: CreatePasskeyMessageType;
  requestId?: string;
  data?: Record<string, unknown>;
  errorCode?: CreatePasskeyErrorCode;
}
